<div class="form-page">
    <!-- <div class="form-header">
        <mat-icon class="header-icon">event</mat-icon>
        <h1>Event Registration</h1>
        <p>Fill in the details below to register your event, stall, and company information</p>
    </div> -->

    <!-- ─────────────────────────── EVENT DETAILS ─────────────────────────── -->
    <mat-card class="form-card">
        <mat-card-header>
            <div mat-card-avatar class="section-avatar section-avatar--event">
                <mat-icon>celebration</mat-icon>
            </div>
            <mat-card-title>Event Details</mat-card-title>
            <mat-card-subtitle>Basic information about the event</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
            <form [formGroup]="eventForm" class="form-grid">

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Event Name</mat-label>
                    <input matInput formControlName="event_name" placeholder="e.g. Tech Expo 2025" />
                    <mat-icon matPrefix>title</mat-icon>
                    <mat-error *ngIf="eventForm.get('event_name')?.hasError('required')">Event name is
                        required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Address</mat-label>
                    <textarea matInput formControlName="address" rows="2" placeholder="Venue address"></textarea>
                    <mat-icon matPrefix>location_on</mat-icon>
                    <mat-error *ngIf="eventForm.get('address')?.hasError('required')">Address is required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>From Date</mat-label>
                    <input matInput [matDatepicker]="fromPicker" formControlName="from_date" placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #fromPicker></mat-datepicker>
                    <mat-icon matPrefix>calendar_today</mat-icon>
                    <mat-error *ngIf="eventForm.get('from_date')?.hasError('required')">Start date is
                        required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>To Date</mat-label>
                    <input matInput [matDatepicker]="toPicker" formControlName="to_date" placeholder="MM/DD/YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                    <mat-datepicker #toPicker></mat-datepicker>
                    <mat-icon matPrefix>event_available</mat-icon>
                    <mat-error *ngIf="eventForm.get('to_date')?.hasError('required')">End date is required</mat-error>
                </mat-form-field>

            </form>
        </mat-card-content>
    </mat-card>

    <!-- ─────────────────────────── STALL DETAILS ─────────────────────────── -->
    <mat-card class="form-card">
        <mat-card-header>
            <div mat-card-avatar class="section-avatar section-avatar--stall">
                <mat-icon>store</mat-icon>
            </div>
            <mat-card-title>Stall Details</mat-card-title>
            <mat-card-subtitle>Description of the stall</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
            <form [formGroup]="stallForm" class="form-grid">

                <mat-form-field appearance="outline">
                    <mat-label>Stall Number</mat-label>
                    <input matInput formControlName="stall_number" placeholder="e.g. A-101" />
                    <mat-icon matPrefix>tag</mat-icon>
                    <mat-error *ngIf="stallForm.get('stall_number')?.hasError('required')">Stall number is
                        required</mat-error>
                </mat-form-field>

            </form>
        </mat-card-content>
    </mat-card>

    <!-- ─────────────────────────── STALL OWNER DETAILS ─────────────────────────── -->
    <mat-card class="form-card">
        <mat-card-header>
            <div mat-card-avatar class="section-avatar section-avatar--owner">
                <mat-icon>business</mat-icon>
            </div>
            <mat-card-title>Stall Owner Details</mat-card-title>
            <mat-card-subtitle>Company and contact information of the stall owner</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
            <form [formGroup]="ownerForm" class="form-grid">

                <!-- Image Upload -->
                <div class="upload-wrapper full-width">
                    <label class="upload-label">
                        <mat-icon>cloud_upload</mat-icon>
                        <span>Upload Owner / Company Image</span>
                        <input type="file" accept="image/*" (change)="onImageChange($event)" hidden />
                    </label>
                    <div *ngIf="imagePreview" class="image-preview">
                        <img [src]="imagePreview" alt="Preview" />
                        <span class="image-name">{{ selectedImage?.name }}</span>
                    </div>
                    <mat-form-field appearance="outline" class="hidden-field">
                        <input matInput formControlName="image_name" />
                    </mat-form-field>
                </div>

                <mat-form-field appearance="outline">
                    <mat-label>Owner Name</mat-label>
                    <input matInput formControlName="owner_name" placeholder="Full name" />
                    <mat-icon matPrefix>person</mat-icon>
                    <mat-error *ngIf="ownerForm.get('owner_name')?.hasError('required')">Owner name is
                        required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Owner Phone Number</mat-label>
                    <input matInput formControlName="owner_number" placeholder="1234567890" />
                    <mat-icon matPrefix>phone</mat-icon>
                    <mat-error *ngIf="ownerForm.get('owner_number')?.hasError('required')">Phone number is
                        required</mat-error>
                    <mat-error *ngIf="ownerForm.get('owner_number')?.hasError('pattern')">Enter a valid phone
                        number</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="email" placeholder="email@company.com" />
                    <mat-icon matPrefix>email</mat-icon>
                    <mat-error *ngIf="ownerForm.get('email')?.hasError('required')">Email is required</mat-error>
                    <mat-error *ngIf="ownerForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Company Name</mat-label>
                    <input matInput formControlName="company_name" placeholder="Company Pvt. Ltd." />
                    <mat-icon matPrefix>apartment</mat-icon>
                    <mat-error *ngIf="ownerForm.get('company_name')?.hasError('required')">Company name is
                        required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Company Address</mat-label>
                    <textarea matInput formControlName="address" rows="2" placeholder="Registered address"></textarea>
                    <mat-icon matPrefix>location_on</mat-icon>
                    <mat-error *ngIf="ownerForm.get('address')?.hasError('required')">Address is required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Website</mat-label>
                    <input matInput formControlName="website" placeholder="https://company.com" />
                    <mat-icon matPrefix>language</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>YouTube</mat-label>
                    <input matInput formControlName="youtube" placeholder="https://youtube.com/@channel" />
                    <mat-icon matPrefix>smart_display</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Instagram</mat-label>
                    <input matInput formControlName="instagram" placeholder="@handle" />
                    <mat-icon matPrefix>photo_camera</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Notes</mat-label>
                    <textarea matInput formControlName="notes" rows="3"
                        placeholder="Any additional notes..."></textarea>
                    <mat-icon matPrefix>notes</mat-icon>
                </mat-form-field>

            </form>
        </mat-card-content>
    </mat-card>

    <!-- ─────────────────────────── ACTIONS ─────────────────────────── -->
</div>
<div class="form-actions">
    <button mat-stroked-button color="warn" type="button" (click)="onReset()">
        <mat-icon>restart_alt</mat-icon> Reset All
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onSubmit()">
        <mat-icon>save</mat-icon> Submit Registration
    </button>
</div>